import { endOfDay, isValid, isWithinInterval, startOfDay } from 'date-fns';

import { Item } from '../../core';
import { DateRange } from '../model/date-range.model';

export function filterByDateRange(
    dateRange: DateRange | null,
    items: Item[],
): Item[] {
    if (
        dateRange == null ||
        !isValid(dateRange.from) ||
        !isValid(dateRange.to)
    ) {
        return [...items];
    }

    const interval = {
        start: startOfDay(dateRange.from),
        end: endOfDay(dateRange.to),
    };

    return items.filter((e) => {
        return isWithinInterval(e.timestamp, interval);
    });
}
